export default __webpack_public_path__ + "static/media/A61.e4d150f3.png";